import React, { useEffect, useState } from 'react';

import Axios from '../utils/axios';

export type MedicineKind = 'default' | 'construction' | 'test';
type MedicineItem = {
	name: string;
	id: string;
	count: number;
	kind?: MedicineKind;
	content?: string[];
};
const Medicines: React.FunctionComponent = () => {
	const [newMedicine, setNewMedicine] = useState<string>('');
	const [kind, setKind] = useState<MedicineKind>('default');
	const [content, setContent] = useState<string[]>([]);
	const [contentItem, setContentItem] = useState<string>('');

	const [medicines, setMedicines] = useState<MedicineItem[]>([]);

	const addMedicine = async () => {
		await Axios.post(`/medicine/`, { name: newMedicine, kind, content });
		setNewMedicine('');
		setContent([]);
	};

	useEffect(() => {
		async function getData() {
			// add no cache header
			let url = `/medicine/?name=${newMedicine}`;
			if (kind !== 'default') {
				url += `&kind=${kind}`;
			}

			const res = await Axios.get(url, {
				headers: {
					'Cache-Control': 'no-cache'
				}
			});
			setMedicines(res.data.items);
		}
		getData();
	}, [newMedicine, kind]);

	const MedicineKinds = [
		['پیشفرش', 'default'],
		['ساختنی', 'construction'],
		['آزمایش', 'test']
	];
	const removeMedicine = async (medicine: MedicineItem) => {
		if (window.confirm('از حذف دارو مطمئن هستید')) {
			const res = await Axios.delete(`/medicine/${medicine.id}`);
			if (res.status === 200) {
				setMedicines(medicines.filter((m) => m.id !== medicine.id));
			}
		}
	};

	return (
		<div className="m-5 text-lg">
			{/* callout */}
			<div
				className="px-4 py-3 text-blue-700 bg-blue-100 border border-blue-500 rounded-md shadow"
				role="alert"
			>
				<p className="font-bold">توجه</p>
				<p className="text-sm">ممکن است اضافه یا حذف یک دارو بعد از ۳ ساعت اعمال شود.</p>
			</div>
			<div className="flex flex-row justify-between mt-5 ">
				<div className="flex">
					<textarea
						className="p-2 ml-5 border-2 border-gray-300 rounded-lg resize-x md:w-96"
						value={newMedicine}
						placeholder="نام دارو"
						rows={1}
						onChange={(e) => setNewMedicine(e.target.value)}
					/>
					<select
						className="p-1 mx-2 rounded-lg"
						value={kind}
						onChange={(e) => setKind(e.target.value as unknown as MedicineKind)}
					>
						{MedicineKinds.map((item) => (
							<option key={item[1]} value={item[1]}>
								{item[0]}
							</option>
						))}
					</select>

					<button
						className="px-4 py-2 ml-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
						onClick={addMedicine}
					>
						افزودن دارو
					</button>
				</div>
				<div className="flex"></div>
			</div>
			{kind === 'construction' && (
				<div className="flex flex-col w-1/2 p-10 mt-5 border-2 border-gray-300 bg-gray-50">
					<label className="text-lg">محتوای دارو: </label>
					<ol className="list-disc">
						{content.map((item, index) => (
							<li key={index} className="flex-row justify-between gap-4 list-item">
								{item}
								<button
									className="px-4 py-2 mx-5 font-bold text-red-500 rounded hover:text-red-700"
									onClick={() => {
										setContent(content.filter((_, i) => i !== index));
									}}
								>
									حذف
								</button>
							</li>
						))}
					</ol>
					<div className="flex flex-row gap-4">
						<input
							className="p-2 border-2 border-gray-300 rounded-lg resize-x md:w-96"
							placeholder="محتوای دارو"
							value={contentItem}
							onChange={(e) => setContentItem(e.target.value)}
						/>
						<button
							className="px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
							onClick={() => {
								setContent([...content, contentItem]);
								setContentItem('');
							}}
						>
							افزودن دارو
						</button>
					</div>
				</div>
			)}
			<table className="mt-10 bg-blue-100 border border-collapse shadow-lg table-auto border-slate-500">
				<thead className="text-gray-700 uppercase bg-blue-200">
					<tr className="">
						<th className="px-4 py-2 border border-slate-700 ">نام دارو</th>
						<th className="px-4 py-2 border border-slate-700 ">تعداد صادر شده</th>
						{kind === 'construction' && (
							<th className="px-4 py-2 border border-slate-700 ">محتوا</th>
						)}
						<th className="px-4 py-2 border border-slate-700 ">عملیات</th>
					</tr>
				</thead>
				<tbody>
					{medicines.map((medicine, i) => (
						<tr key={medicine.id} className={`hover:bg-blue-200 ${i % 2 && 'bg-blue-50'}`}>
							<td className="px-4 py-2 border border-slate-700 ">{medicine.name}</td>
							<td className="px-4 py-2 border border-slate-700 ">{medicine.count}</td>
							{kind === 'construction' && (
								<td className="px-4 py-2 border border-slate-700 ">
									{medicine.content?.map((item, index) => (
										<span key={index} className="flex-row">
											{item} --{' '}
										</span>
									))}
								</td>
							)}
							<td className="px-4 py-2 border border-slate-700">
								<button
									className="px-4 py-2 text-sm font-bold text-red-600 rounded border-slate-700 hover:text-red-900 "
									onClick={() => removeMedicine(medicine)}
								>
									حذف
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default Medicines;
